import { createSlice } from "@reduxjs/toolkit";

interface LocalStorageState {
  isLoading: boolean;
  error?: any;
}

const initialState: LocalStorageState = {
  isLoading: false,
  error: null,
};

const localStorageSlice = createSlice({
  name: "localStorage",
  initialState,
  reducers: {
    getSavedStateFromLocalStorageStart: (state) => {
      state.isLoading = true;
    },

    getSavedStateFromLocalStorageSucceeded: (state) => {
      state.isLoading = false;
    },

    getSavedStateFromLocalStorageFailed: (state) => {
      state.isLoading = false;
    },

    saveStateToLocalStorageSucceeded: (state) => {
      state.isLoading = false;
    },

    saveStateToLocalStorageFailed: (state) => {
      state.isLoading = false;
    },
  },
});

export const {
  getSavedStateFromLocalStorageFailed,
  getSavedStateFromLocalStorageStart,
  getSavedStateFromLocalStorageSucceeded,
  saveStateToLocalStorageFailed,
  saveStateToLocalStorageSucceeded,
} = localStorageSlice.actions;
export const localStorage = localStorageSlice.reducer;
